const SettingRow = ({ label, InputComponent, ...props }) => {
  return (
    <div className='my-4 items-center pt-3 sm:flex'>
      <div className='mb-2 font-bold sm:mb-0 sm:w-1/3 md:w-1/4 lg:w-1/5'>
        <label htmlFor={props.id}>{label}</label>
      </div>
      <div className='w-full sm:w-2/3 md:w-1/2'>
        <InputComponent {...props} />
      </div>
    </div>
  );
};

export default SettingRow;
